var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.isAdmin
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "mt-6 mb-6" }, [
          _c("h2", { staticClass: "text-lg font-sans text-n-gray-dark mb-4" }, [
            _vm._v("Active Collaborators Report"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-sm mb-4 text-gray-600" }, [
            _vm._v(
              "\n      Find users who hosted events or added resources within a date range.\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-wrap items-end mb-4" }, [
            _c(
              "div",
              { staticClass: "w-full md:w-1/4 pr-0 md:pr-4 mb-3 md:mb-0" },
              [
                _c("label", { staticClass: "block text-sm font-bold mb-1" }, [
                  _vm._v("Start Date"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.startDate,
                      expression: "startDate",
                    },
                  ],
                  staticClass: "w-full border p-2",
                  attrs: { type: "date" },
                  domProps: { value: _vm.startDate },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.startDate = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full md:w-1/4 pr-0 md:pr-4 mb-3 md:mb-0" },
              [
                _c("label", { staticClass: "block text-sm font-bold mb-1" }, [
                  _vm._v("End Date"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.endDate,
                      expression: "endDate",
                    },
                  ],
                  staticClass: "w-full border p-2",
                  attrs: { type: "date" },
                  domProps: { value: _vm.endDate },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.endDate = $event.target.value
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full md:w-1/4 pr-0 md:pr-4 mb-3 md:mb-0" },
              [
                _c(
                  "button",
                  {
                    staticClass: "button mb-0",
                    attrs: { disabled: _vm.loading },
                    on: { click: _vm.fetchReport },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.loading ? "Loading..." : "View Report") +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "w-full md:w-1/4 mb-3 md:mb-0" }, [
              _c(
                "button",
                {
                  staticClass: "button mb-0",
                  attrs: { disabled: _vm.exporting || !_vm.hasResults },
                  on: { click: _vm.exportCsv },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.exporting ? "Exporting..." : "Export CSV") +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.error
          ? _c(
              "div",
              {
                staticClass:
                  "bg-red-100 border border-red-400 text-red-700 px-4 py-3 mb-4",
              },
              [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasResults
          ? _c("div", { staticClass: "mt-4" }, [
              _c("p", { staticClass: "text-sm mb-3 text-gray-600" }, [
                _vm._v("\n      Found "),
                _c("strong", [_vm._v(_vm._s(_vm.collaborators.length))]),
                _vm._v(" active collaborator(s).\n    "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "responsive-table" }, [
                _c("table", { staticClass: "w-full" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.collaborators, function (collab) {
                      return _c("tr", { key: collab.id }, [
                        _c(
                          "td",
                          { staticClass: "p-4 border border-grey-light" },
                          [_vm._v(_vm._s(collab.id))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "p-4 border border-grey-light" },
                          [_vm._v(_vm._s(collab.email))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "p-4 border border-grey-light" },
                          [_vm._v(_vm._s(collab.first_name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "p-4 border border-grey-light" },
                          [_vm._v(_vm._s(collab.last_name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "p-4 border border-grey-light" },
                          [_vm._v(_vm._s(collab.event_titles || "-"))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "p-4 border border-grey-light" },
                          [_vm._v(_vm._s(collab.resource_titles || "-"))]
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.searched && !_vm.hasResults && !_vm.loading
          ? _c("div", { staticClass: "mt-4 text-center font-bold" }, [
              _vm._v(
                "\n    No active collaborators found for the selected date range.\n  "
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex-wrap flex-col md:flex-row" }, [
      _c("div", { staticClass: "w-full md:w-1/2" }, [
        _c(
          "h1",
          { staticClass: "mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark" },
          [_vm._v("Admin Dashboard")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left p-4 border border-grey-light" }, [
          _vm._v("ID"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-4 border border-grey-light" }, [
          _vm._v("Email"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-4 border border-grey-light" }, [
          _vm._v("First Name"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-4 border border-grey-light" }, [
          _vm._v("Last Name"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-4 border border-grey-light" }, [
          _vm._v("Events"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-4 border border-grey-light" }, [
          _vm._v("Resources"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }